import React, { useEffect } from "react";

function MicroFrontend({ name, host, history }) {
  useEffect(() => {
    const scriptId = `micro-frontend-script-${name}`;

    const renderMicroFrontend = () => {
      window[`render${name}`](`${name}-reactProject`, history);
    };

    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    }

    fetch(`${host}/asset-manifest.json`)
      .then((res) => res.json())
      .then((manifest) => {
        const script = document.createElement("script");
        script.id = scriptId;
        script.crossOrigin = "";
        script.src = `${host}${manifest.files["main.js"]}`;

        document.head.appendChild(script);
        const link = document.createElement("link");
        link.id = scriptId;
        link.href = `${host}${manifest.files["main.css"]}`;
        link.rel = "stylesheet";
        document.head.appendChild(link);

        script.onload = () => {
          renderMicroFrontend();
        };
      });

    return () => {
      window[`unmount${name}`] &&
        window[`unmount${name}`](`${name}-reactProject`);
    };
  });

  return <main id={`${name}-reactProject`} />;
}

MicroFrontend.defaultProps = {
  document,
  window
};

export default MicroFrontend;
